import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../../utils/auth';

const NonAuthLayout = (props) => {
  if (isAuthenticated()) {
    return (
      <Navigate to="/home" replace />
    );
  }

  return (
    <React.Fragment>
      {props.children}
    </React.Fragment>
  )
}

export default NonAuthLayout
